<template lang="pug">
  .componend-mdi-icon
    template(v-if="icon" )
      svg(xmlns='http://www.w3.org/2000/svg')
        path(fill='currentColor' :d='icon')
      div(v-if="showName" ) {{name}}
    template(v-else)
      slot

</template>

<script>
import * as mdi from '@mdi/js'

export default {
  name: "MdiIcon",
  components: {},
  data() {
    return {
      icons: mdi,

    }
  },
  created() {

  },
  computed: {
    icon() {
      const iconName = this.name.replace(/-([a-z])/g, function (m, w) {
        return w.toUpperCase();
      });
      return mdi[iconName]
    }
  },
  props: {
    name: {
      type: String,
    },
    showName: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="sass" rel="stylesheet/sass">
.componend-mdi-icon
  text-align: center

  svg
    height: 1em
    width: 2em
</style>



// WEBPACK FOOTER //
// MdiIcon.vue?436f0329